import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GridComponent, GridLine } from '@syncfusion/ej2-angular-grids';
import { forkJoin, lastValueFrom, Subscription } from 'rxjs';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { RentalService } from 'src/app/services/Rental.service';
import { UserService } from 'src/app/services/User.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { DiscountType } from 'src/app/Shared/enum';
import { SharedDataService } from 'src/app/Shared/SharedData.service';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-eventrental-online',
  templateUrl: './eventrental-online.component.html',
  styleUrls: ['./eventrental-online.component.scss','../rent-online.component.scss']
})
export class EventrentalOnlineComponent implements OnInit, OnDestroy {
  priorBalance;
  totalDiscountCharge;
  private subscriptions: Subscription[] = [];
  public filterSettings: Object;
  public lines: GridLine;
  parts;
  boothParts;
  srcBoothNumber;
  layoutParts;
  eventMarketDays;
  marketId;
  allAvailableBooths = [];
  vendorDiscountPlans = [];
  selectedBooths = [];
  isboothSelected;
  eventList = [];
  resaleNoDisplay = false;
  defaultPartId;
  OtherChargesPeriod = false;
  secondTaxName = "";
  DisplayPayDueDate = false;
  DisplaySpecificDate = false;
  DisplayOptionValue = 0;
  displayOtherChargeByBooth = false;
  UseSignaturePad: boolean = false;
  othChgBooths = "none";
  displaySalesTax = false;
  displayCityTax = false;
  displayOtherChargeSalesTax = false;
  displayOtherChargeCityTax = false;
  warnExcessPayment = false;
  warnZeroPayment = false;
  ResaleNumberRequired = false;
  DaysSellWithoutResaleNumber;
  CheckExpiredOrBlankBLLicNo = false;
  BusinessLicenseNumberRequired = false;
  DaysSellWithoutBusiLicNumber;
  RentalTaxPercentage = 0;
  OtherRentalTaxPercentage = 0;
  RentalSecondTaxPercentage = 0;
  OtherRentalSecondTaxPercentage = 0;
  otherChargeEventId;
  isSwalOpen = false;
  tempRecordNo;
  otherRentalCharges = [];
  selectedOtherCharges = [];
  otherChargeMarketDay;
  otherItemList = [];
  otherChargeEventType = "2";
  otherItemEventID;
  displayLayoutPopup = false;
  displayDefaultPart = false;
  public loaderIcon: Promise<boolean>;
  public loadHourGlassLoader: Promise<boolean>;
  selectedBoothData = [];
  selectedDays = [];
  selectedOtherChargeDays = [];
  selectedBoothsForRental = [];
  businessLicenseDisplay = false;
  isdirty = false;
  disableSave = true;
  @Output() isFormDirty = new EventEmitter<any>();
  @Output() isCancelClicked = new EventEmitter<any>();
  @Output() bookingFormCompleted = new EventEmitter<any>();
  @Output() rentalBookingData = new EventEmitter<any>();
  @Output() resaleNoInputRequired = new EventEmitter<any>();
  @Output() businessLicenseRequired = new EventEmitter<any>();
  @ViewChild('gridEvents', { static: false }) public gridEvents: GridComponent;
  @ViewChild('gridEvtOtherRentals', { static: false }) public gridEvtOtherRentals: GridComponent;
  @ViewChild('modalResaleNo', { static: false }) modalResaleNo: ElementRef;
  @ViewChild('modalOtherCharges', { static: false }) modalOtherCharges: ElementRef;
  @ViewChild('modalOtherChargeOption', { static: false }) modalOtherChargeOption: ElementRef;
  businessLicenseNumber;
  businessLicenseExpiryDate;
  vendorRentalDays = [];
  exemptResale = false;
  resaleNoOption = "1";
  resaleNo = "";
  exemptResaleReason = "";
  resaleOptionSelected = false;
  ResaleOrBusinessHeader = "";
  marketWeekCountForResale = 0;
  marketDayCountForResale = 0;
  resaleNoByweek = false;
  vendorId;
  vendorProducts = [];
  totalRentalCharge = 0.00;
  totalOtherRentalCharge = 0.00;
  totalSalesTax = 0.00;
  totalSecondLeveltax = 0.00
  totalCharge = 0.00;
  exemptSalesTax = false;
  exemptSecondLvlTax = false;
  boothsForOtherCharge = [];
  otherItemSearchText;
  selectedOtherItems = [];
  displayLayout = false;
  disableDiscountAmount = true;
  rentalForm: FormGroup;
  AllowRentingOtherItems = false;
  @Input() newVendor;
  defaultProduct;
  defaultPart;
  dailyEvent = false;
  totalEvent = false;

  constructor(private renderer: Renderer2,
    private formbuilder: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    public rentalService: RentalService,
    public vendorService: VendorService,
    private customCurrency: customCurrencyPipe,
    private datePipe: DatePipe,
    private userService: UserService,
    private sharedDataService: SharedDataService,
    private marketInfoService: MarketInfoService) {
    this.rentalForm = this.formbuilder.group({
      marketParts: [''],
      eventId: [''],
      eventOptions: ["2"]
    })
  }

  ngOnInit(): void {
    this.marketId = this.userService.getMarketId();
    this.vendorId=this.userService.getVendorId() || 0;
    this.generateTempRecordNumber();
    this.getVendorProducts();
    this.checkAvailableEvent(0);
    this.getParts();
    this.getMarketVendorSettings();
    this.getVendorBusinessLicenseSettings();
    this.getVendorBalances();
    this.getOtherRentalItems();
  }

  generateTempRecordNumber() {
    this.subscriptions.push(this.rentalService.generateTempRecordNumber(this.marketId).subscribe((response) => {
      if (response.Success) {
        this.tempRecordNo = response.Message;
      }
    }));
  }

  getParts() {
    const sub = this.marketInfoService.getParts(this.marketId).subscribe((res: any) => {
      if (res) {
        this.parts = res;
        this.getWebRentalSetting();
      }
    }, err => {
    });
    this.subscriptions.push(sub);
  }

  changeOtherChargeEventType() {
    this.getOtherRentalItems();
  }

  setDefaultRentalItem(args, selectedItems) {
    selectedItems.Quantity = 0;
    selectedItems.OtherItemtotal = this.customCurrency.transform("0").toString();
    selectedItems.Reference = "";
    if (args.srcElement.checked) {
      selectedItems.otherItemChecked = true;
      selectedItems.Quantity = 1
      const isNegative = selectedItems.OtherItemCharge.includes('(') && selectedItems.OtherItemCharge.includes(')');
      const totalValue = parseFloat(selectedItems.OtherItemCharge.replace(/[^0-9.-]/g, ''));
      const finalCharge = isNegative ? -totalValue : totalValue;
      selectedItems.OtherItemtotal = this.customCurrency.transform((finalCharge * selectedItems.Quantity).toString());
      this.selectedOtherCharges.push({
        Id: selectedItems.Id,
        OtherItem: selectedItems.OtherItem,
        OtherItemCharge: selectedItems.OtherItemCharge,
        Quantity: selectedItems.Quantity,
        OtherItemtotal: selectedItems.OtherItemtotal,
        othChgBooths: selectedItems.othChgBooths,
        RentalDay: this.datePipe.transform(this.otherChargeMarketDay, "MM/dd/yyyy"),
      });
    } else {
      selectedItems.otherItemChecked = false;
      const index = this.selectedOtherCharges.findIndex(item => item.Id === selectedItems.Id);
      if (index !== -1) {
        this.selectedOtherCharges.splice(index, 1);
      }

      this.subscriptions.push(this.rentalService.getOtherRentalItems(this.marketId).subscribe((response) => {
        if (response) {
          const masterChargeRecord = response.filter(item => item.OtherItemId == selectedItems.Id);
          if (masterChargeRecord) {
            selectedItems.OtherItemCharge = this.rentalForm.get('eventOptions').value == '1' ? this.customCurrency.transform(masterChargeRecord[0].OtherItemEventDailyCharge)
              : this.customCurrency.transform(masterChargeRecord[0].OtherItemEventTotalCharge);
          }
        }
      }, (err) => {
      }));
    }
  }

  isDateSelected(item: any): boolean {
    var isItemSelected = this.selectedOtherItems.some(
      (element) =>
        this.datePipe.transform(element.RentalDay, 'MM/dd/yyyy') ===
        this.datePipe.transform(this.otherChargeMarketDay, 'MM/dd/yyyy') &&
        element.Id === item.Id && element.NewItem == true
    );

    if (!isItemSelected) {
      isItemSelected = this.selectedOtherCharges.some(
        (element) =>
          this.datePipe.transform(element.RentalDay, 'MM/dd/yyyy') ===
          this.datePipe.transform(this.otherChargeMarketDay, 'MM/dd/yyyy') &&
          element.Id === item.Id
      );
    }

    !isItemSelected ? item.otherItemChecked = false : item.otherItemChecked = true;
    return isItemSelected;
  }

  checkAvailableEvent(requestType) {
    this.subscriptions.push(this.rentalService.getAvailableEvent(this.marketId).subscribe((res: any) => {
      if (!res) {
        Swal.fire({
          title: $localize`Info`,
          text: $localize`There are no Events available for Advanced booking !!`,
          icon: "info",
          confirmButtonText: $localize`Ok`,
        });
      } else {
        this.eventList = res;
        this.rentalForm.get('eventId').setValue(res[0]?.EventID);
        this.otherChargeEventId = res[0]?.EventID;
        this.getEventMarketDays();

        if (requestType == 1) {
          // if (this.dailyEvent && this.totalEvent) {
          //   const modal = this.modalOtherChargeOption.nativeElement;
          //   if (!modal.classList.contains('show')) {
          //     $(modal).modal('show');
          //   }
          // } else {
            this.openOtherChargeModal();
         // }
        }
      }
    }));
  }

  openLayout() {
    if (this.rentalForm.get('eventOptions').value == '2') {
      this.selectedDays = [];
      for (var item of this.eventMarketDays) {
        this.selectedDays.push(new Date(item.MarketDays));
      }
    }
    if (this.selectedDays.length == 0) {
      Swal.fire({
        text: $localize`Please select a market day`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    else if (this.layoutParts == 0) {
      Swal.fire({
        text: $localize`Please select a part`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    else {
      this.layoutParts = this.rentalForm.value['marketParts'];
      this.sharedDataService.dailyRentalSelectedDays = this.selectedDays;
      this.sharedDataService.dailyRentalSelectedBooths = this.selectedBooths.filter(e => e.NewBooth == true);
      this.sharedDataService.tempRecordNo = this.tempRecordNo;
      this.sharedDataService.eventId = this.rentalForm.get('eventId').value;
      this.displayLayout = true;
    }
  }

  selectedBoothsFromLayout(data) {
    window.scrollTo(0, 0);
    this.selectedDays.forEach(date => {
      this.selectedBooths = this.selectedBooths.filter(e => !e.NewBooth);
    });
    this.selectedBooths = this.selectedBooths.concat(this.sharedDataService.dailyRentalSelectedBooths);

    data.forEach(el => {
      this.selectedDays.forEach(date => {
        var recordExist = this.sharedDataService.dailyRentalSelectedBooths.filter(e => e.BoothNumber == el.BoothNumber && this.datePipe.transform(e.RentalDay, 'MM/dd/yyyy') == this.datePipe.transform(date, 'MM/dd/yyyy'));
        if (recordExist.length == 0) {
          var index = this.selectedBoothData.findIndex(e => e.BoothNumber == el.BoothNumber && e.BoothTypeId == el.BoothTypeId)
          if (index == -1) {
            this.selectedBoothData.push(
              {
                BoothNumber: el.BoothNumber,
                BoothType: el.BoothType,
                BoothTypeId: el.BoothTypeId,
              });
          }
        }
      });
    });
    this.displayLayout = false;
    this.getRentalPaymentSettings();
    if (this.selectedBoothData.length > 0)
      this.validateAndAddSelectedBoothsToGrid();
  }

  validateAndAddSelectedBoothsToGrid() {
    let noResale = true;
    this.vendorRentalDays = [];
    this.marketDayCountForResale = 0
    if ((this.ResaleNumberRequired && !this.exemptResale) || (this.BusinessLicenseNumberRequired)) {

      const currentYear = new Date().getFullYear();
      var selectedBoothRecord = this.selectedBooths.filter(e => e.NewBooth == true && new Date(e.RentalDay).getFullYear() == currentYear);
      if (selectedBoothRecord.length > 0) {
        selectedBoothRecord.forEach(record => {
          const targetDateString = this.datePipe.transform(record.RentalDay, "MM/dd/yyyy");
          const dateExist = this.vendorRentalDays.find(el => {
            const rentalDateString = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
            return rentalDateString === targetDateString;
          });
          if (!dateExist) {
            const formattedDate = this.datePipe.transform(record.RentalDay, "MM/dd/yyyy");
            this.vendorRentalDays.push({ VendorRentalDate: formattedDate });
            this.marketDayCountForResale += 1;
            if (this.marketDayCountForResale > this.DaysSellWithoutResaleNumber) {
              return; // exits the forEach loop when the condition is met
            }
          }
        });
      }

      this.selectedDays.map(date => {
        const targetDateString = this.datePipe.transform(date, "MM/dd/yyyy");
        const dateExist = this.vendorRentalDays.find(el => {
          const rentalDateString = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
          return rentalDateString === targetDateString;
        });
        if (!dateExist) {
          const formattedDate = this.datePipe.transform(date, "MM/dd/yyyy");
          this.vendorRentalDays.push({ VendorRentalDate: formattedDate });
          this.marketDayCountForResale += 1;
          if (this.marketDayCountForResale > this.DaysSellWithoutResaleNumber) {
            return; // exits the forEach loop when the condition is met
          }
        }
      });

      const obj = {
        VendorID: this.vendorId,
        VendorRentalDate: new Date(),
        MarketId: this.marketId
      };

      this.subscriptions.push(this.rentalService.getVendorRentalDays(obj).subscribe((res: any[]) => {
        if (this.marketDayCountForResale <= this.DaysSellWithoutResaleNumber || this.marketDayCountForResale <= this.DaysSellWithoutBusiLicNumber) {
          if (res && res.length > 0) {
            res.forEach(el => {
              const targetDateString = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
              const dateExist = this.vendorRentalDays.find(data => {
                const rentalDateString = this.datePipe.transform(data.VendorRentalDate, "MM/dd/yyyy");
                return rentalDateString === targetDateString;
              });
              if (!dateExist) {
                const formattedDate = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
                this.vendorRentalDays.push({ VendorRentalDate: formattedDate });
                this.marketDayCountForResale += 1;
              }
            });
          }
        }

        if (!this.newVendor) {
          if (this.ResaleNumberRequired && !this.exemptResale && !this.resaleNo && this.marketDayCountForResale > this.DaysSellWithoutResaleNumber && !this.resaleOptionSelected) {
            const modal = this.modalResaleNo.nativeElement;
            modal.classList.add('show');
            if (modal.classList.contains('show')) {
              modal.style.display = 'block';
              this.ResaleOrBusinessHeader = "Resale Number"
              this.resaleNoDisplay = true;
              this.businessLicenseDisplay = false;
            }
            noResale = false;
          }
          else if (this.BusinessLicenseNumberRequired && this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
            if (!this.businessLicenseNumber || !this.businessLicenseExpiryDate) {
              const modal = this.modalResaleNo.nativeElement;
              modal.classList.add('show');
              if (modal.classList.contains('show')) {
                modal.style.display = 'block';
                this.ResaleOrBusinessHeader = "Business License Number";
                this.resaleNoDisplay = false;
                this.businessLicenseDisplay = true;
              }
              noResale = false;
            }
            else {
              if (this.getDateFromDateTime(new Date(this.businessLicenseExpiryDate)) < this.getDateFromDateTime(new Date())) {
                Swal.fire({
                  title: $localize`Warning`,
                  text: $localize`Business License is expired! Please contact the market`,
                  icon: "warning",
                  confirmButtonText: $localize`Ok`,
                });
              }
              else {
                this.addSelectedBoothsToGrid();
              }
            }
          }
          else {
            noResale = true;
            this.addSelectedBoothsToGrid();
          }
        }
        else {
          if (this.ResaleNumberRequired && !this.exemptResale && !this.resaleNo && this.marketDayCountForResale > this.DaysSellWithoutResaleNumber && !this.resaleOptionSelected) {
            this.resaleNoInputRequired.emit(true)
          }
          if (this.BusinessLicenseNumberRequired && this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
            this.businessLicenseRequired.emit(true);
          }
          this.addSelectedBoothsToGrid();
        }
      }));
    } else {
      this.addSelectedBoothsToGrid();
    }
  }

  clearExistingData() {
    this.displayLayoutPopup = false;
    this.srcBoothNumber = "";
    this.boothParts = this.defaultPartId;
    this.selectedDays = [];
  }

  getWebRentalSetting() {
    const sub = this.marketInfoService.getWebRentalSetting(this.marketId).subscribe((res: any) => {
      if (res) {
        this.defaultPart = res.DefaultLayoutPart;
        this.dailyEvent = res.DailyEvent;
        this.totalEvent = res.TotalEvent;
        if (this.dailyEvent && this.totalEvent) {
          this.rentalForm.get('eventOptions').setValue("2");
          this.otherChargeEventType == "2";
        }
        else {
          this.rentalForm.patchValue({
            eventOptions : this.dailyEvent ? "1" : "2"
          });
          this.otherChargeEventType = this.dailyEvent ? "1" : "2"
        } 
        this.rentalForm.get('marketParts').setValue(this.defaultPart);
        this.AllowRentingOtherItems = res.AllowRentingOtherItems;
        this.getRentalPaymentSettings();
      }
    }, err => {
    });
    this.subscriptions.push(sub);
  }

  getRentalPaymentSettings() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.rentalService.getRentalSettings(this.marketId).subscribe((res: any) => {
      if (res) {
        this.warnExcessPayment = res.WarnExcessPayment;
        this.warnZeroPayment = res.WarnZeroPayment;
        this.displayOtherChargeByBooth = res.DisplayOtherChargesByBooth;
        this.displaySalesTax = res.RentalTaxable;
        this.displayCityTax = res.RentalSecondTaxable;
        this.displayOtherChargeSalesTax = res.OtherRentalTaxable;
        this.displayOtherChargeCityTax = res.OtherRentalSecondTaxable;
        this.gridEvents.getColumnByField("SalesTax").visible = this.displaySalesTax;
        this.gridEvents.getColumnByField("CityTax").visible = this.displayCityTax;
        if (this.newVendor) {
          this.gridEvents.getColumnByField("Product").visible = false;
        }
        this.ResaleNumberRequired = res.ResaleNumberRequired;
        this.DaysSellWithoutResaleNumber = res.DaysSellWithoutResaleNumber;
        this.BusinessLicenseNumberRequired = res.BusinessLicenseNumberRequired;
        this.DaysSellWithoutBusiLicNumber = res.DaysSellWithoutBusiLicNumber;
        this.DisplayPayDueDate = res.DisplayPayDueDate;
        this.DisplaySpecificDate = res.DisplaySpecificDate;
        this.DisplayOptionValue = res.DisplayOptionValue;
        this.secondTaxName = res.SecondTaxName ? res.SecondTaxName : "Sec Level Tax"
        var secLevelTaxRentHeader = this.gridEvents.getColumnByField("CityTax");
        secLevelTaxRentHeader.headerText = this.secondTaxName;
        this.OtherChargesPeriod = res.OtherChargesPeriod;
        if (this.AllowRentingOtherItems) {
          var secLevelTaxOtherRentHeader = this.gridEvtOtherRentals.getColumnByField("CityTax");
          this.gridEvtOtherRentals.getColumnByField("BoothNo").visible = res.DisplayOtherChargesByBooth;
          this.gridEvtOtherRentals.getColumnByField("SalesTax").visible = this.displayOtherChargeSalesTax;
          this.gridEvtOtherRentals.getColumnByField("CityTax").visible = this.displayOtherChargeCityTax;
          secLevelTaxOtherRentHeader.headerText = this.secondTaxName;
        }
        const nextDate = this.getNextDate(this.DisplayOptionValue);
        this.gridEvents.refresh();
        if (this.AllowRentingOtherItems) {
          this.gridEvtOtherRentals.refresh();
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getNextDate(day: number): Date {
    if (this.DisplaySpecificDate) {
      const today = new Date();
      let nextDate = new Date(today.getFullYear(), today.getMonth(), day);
      // If the nextDate is in the past or today, move to the next month
      if (nextDate < today) {
        nextDate.setMonth(nextDate.getMonth() + 1);
      }
      // Handle cases where the day is not valid in the next month (e.g., 31st in February)
      while (nextDate.getDate() !== day) {
        nextDate.setMonth(nextDate.getMonth() + 1);
        nextDate.setDate(day);
      }
      return nextDate;
    }
    else {
      const today = new Date();
      let nextDate = new Date(today.setDate(today.getDate() + day));
      return nextDate;
    }
  }

  getMarketVendorSettings() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.vendorService.getMarketVendorSettings(this.vendorId, this.marketId).subscribe((res: any) => {
      var response = res.body;
      if (response) {
        this.exemptResale = response.ExemptResale;
        this.resaleNo = response.Resale;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getVendorBusinessLicenseSettings() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.vendorService.getVendorBusinessLicenseSettings(this.vendorId, this.marketId).subscribe((res: any) => {
      if (res) {
        this.businessLicenseNumber = res.LicenseNumber;
        this.businessLicenseExpiryDate = res.ExpiryDate;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getVendorProducts() {
    if (this.vendorId) {
      this.loaderIcon = Promise.resolve(true);
      const sub = this.rentalService.GetVendorProductsById(this.marketId, this.vendorId).subscribe((res: any) => {
        if (res) {
          this.vendorProducts = res.body;
          this.defaultProduct = this.vendorProducts[0].ProductId;
          this.loaderIcon = Promise.resolve(false);
        }
      }, err => {
        this.loaderIcon = Promise.resolve(false);
      });
      this.subscriptions.push(sub);
    }
  }

  getVendorBalances() {
    this.vendorDiscountPlans = [];
    forkJoin({
      vendorBalanceRes: this.rentalService.getVendorBalances(this.vendorId, this.marketId),
      discountPlansRes: this.vendorService.GetDiscountPlan(this.vendorId, this.marketId)
    }).subscribe(
      ({ vendorBalanceRes, discountPlansRes }: any) => {
        if (vendorBalanceRes) {
          this.priorBalance = vendorBalanceRes.PriorBalance ?? 0;
        }
        if (discountPlansRes) {
          if (discountPlansRes) {
            for (const el of discountPlansRes) {
              if (el.Daily && el.OnlineTransactions) {
                const ob = {
                  PlanSeqId: el.PlanSeqId,
                  PlanId: el.PlanId,
                  PlanName: el.PlanName,
                  EffectiveFrom: this.datePipe.transform(el.EffectiveFrom, 'MM/dd/yyyy'),
                  ExpiryDate: this.datePipe.transform(el.ExpiryDate, 'MM/dd/yyyy'),
                  DiscountType: el.DiscountType == 0 ? DiscountType.Percentage : DiscountType.FixedAmount,
                  DiscountValue: el.DiscountValue,
                  OtherItems: el.OtherItems,
                  Daily: el.Daily,
                  Weekly: el.Weekly,
                  Monthly: el.Monthly,
                  CombinedWeekly: el.CombinedWeekly,
                  CombinedMonthly: el.CombinedMonthly,
                  IsExceedAmount: el.IsExceedAmount,
                  ExceedAmount: el.ExceedAmount,
                  BalanceDue: el.BalanceDue,
                  Notes: el.Notes,
                  QDR: el.QDR,
                  CheckAll: el.Selected,
                  AutoSelected: el.Selected,
                  DisableDiscount: el.Selected,
                  AppliedDiscount: this.customCurrency.transform("0.00"),
                  SalesTaxAmount: this.customCurrency.transform("0.00"),
                  SecondLevelTaxAmount: this.customCurrency.transform("0.00"),
                  SalesTaxApplied: el.SalesTax,
                  SecondLevelTaxApplied: el.SecondLevelTax,
                }
                this.vendorDiscountPlans.push(ob);
              }
            }
            this.loaderIcon = Promise.resolve(false);
            this.disableDiscountAmount = this.vendorDiscountPlans.length > 0 ? false : true;
          }
          this.getDiscounts();
        }
      })
  }

  getOtherRentalItems() {
    var rentalDate = '';
    if (this.otherChargeMarketDay)
      rentalDate = this.datePipe.transform(this.otherChargeMarketDay, 'MM/dd/yyyy');
    this.subscriptions.push(this.rentalService.getOtherRentalItems(this.marketId, rentalDate).subscribe((response) => {
      if (response) {
        response.map((el, i) => {
          if (el.WebRental) {
            const ob = {
              Id: el.OtherItemId,
              OtherItem: el.OtherItem,
              OtherItemCharge: this.rentalForm.get('eventOptions').value == '1' ? this.customCurrency.transform(el.OtherItemEventDailyCharge)
                : this.customCurrency.transform(el.OtherItemEventTotalCharge),
              Quantity: 0,
              OtherItemtotal: this.customCurrency.transform('0'),
              othChgBooths: "none"
            }
            this.otherRentalCharges.push(ob);
            this.otherItemList.push(ob);
          }
        });
      }
    }, (err) => {
    }));
  }

  getDiscounts() {
    var totalRentalCharge = this.totalRentalCharge;
    var totalSalesTax = this.totalSalesTax;
    var totalSecondLeveltax = this.totalSecondLeveltax;
    var totalOtherRentalCharge = this.totalOtherRentalCharge;
    var priorBalance = 0;
    var totalChargeWithDue = this.priorBalance + (totalRentalCharge)
      + (totalSalesTax)
      + (totalSecondLeveltax)
      + (totalOtherRentalCharge)

    var totalCharge = (totalRentalCharge) + (totalSalesTax) + (totalSecondLeveltax) + (totalOtherRentalCharge)
    //   totalCharge = totalCharge.toString().includes('(') && totalCharge.toString().includes(')') ? -1 * parseFloat(totalCharge.toString().replace(/[^0-9.-]/g, '')) : parseFloat(totalCharge.toString().replace(/[^0-9.-]/g, ''));

    if (this.vendorDiscountPlans.length > 0 && totalCharge > 0) {
      var discountTotalAmount = 0;
      var totalAmountForDiscount = 0;
      for (const disc of this.vendorDiscountPlans) {
        disc.CheckAll = disc.AutoSelected;
        if (disc.CheckAll && disc.Daily) {
          var currentDiscountValue = 0;
          if (!disc.BalanceDue || (disc.BalanceDue && priorBalance <= 0)) {
            if (!disc.IsExceedAmount || (disc.IsExceedAmount && totalCharge > disc.ExceedAmount)) {
              const discountValue = disc.DiscountValue;
              totalAmountForDiscount = totalRentalCharge
              if (disc.OtherItems) {
                totalAmountForDiscount += totalOtherRentalCharge
              }
              if (disc.DiscountType == 'Percentage') {
                discountTotalAmount += totalAmountForDiscount * (discountValue / 100);
                currentDiscountValue = totalAmountForDiscount * (discountValue / 100);
              }
              else {
                discountTotalAmount += discountValue;
                currentDiscountValue = discountValue;
              }
            }
            else {
              disc.CheckAll = false;
            }
          }
          else {
            disc.CheckAll = false;
          }
          disc.AppliedDiscount = this.customCurrency.transform(currentDiscountValue.toString());
        }
        else {
          disc.AppliedDiscount = this.customCurrency.transform("0");
        }

        this.totalDiscountCharge = discountTotalAmount.toString();
      }
    }
  }

  async getBoothsAndItemsForOtherCharges() {
    if (this.OtherChargesPeriod) {
      this.otherRentalCharges = [];
      this.otherItemList = [];
      await this.getOtherRentalItems();
    }
    this.boothsForOtherCharge = [];
    this.selectedOtherCharges = [];
    if (this.otherChargeMarketDay) {
      this.selectedBooths.forEach((item) => {
        if (this.datePipe.transform(item.RentalDay, 'MM/dd/yyyy') == this.datePipe.transform(this.otherChargeMarketDay, 'MM/dd/yyyy')) {
          this.boothsForOtherCharge.push({ BoothNumber: item.BoothNumber })
        }
      });
    }

    if (this.boothsForOtherCharge.length > 0 && this.otherRentalCharges.length > 0) {
      for (const item of this.otherRentalCharges) {
        item.othChgBooths = "none"
      }
    }

    this.boothsForOtherCharge.sort((a, b) => {
      if (a.BoothNumber < b.BoothNumber) {
        return -1;
      }
      if (a.BoothNumber > b.BoothNumber) {
        return 1;
      }
      return 0;
    });
  }

  disableSavePayment() {
    var vendorBalance = (this.priorBalance ?? 0) + this.totalCharge;
    if (((vendorBalance > 0) || (this.priorBalance < 0 && vendorBalance <= 0)) &&
      (this.selectedBooths.length > 0 || this.selectedOtherItems.length > 0)) {
      return false
    }
    else
      return true
  }

  closeLayoutForm() {
    this.displayLayout = false;
  }

  AddBoothsOnGridOnValidationSucess() {
    var addToGrid = false;
    var closeModalPopup = false;
    const modal = this.modalResaleNo.nativeElement;
    if (this.resaleNoDisplay) {
      if (!this.resaleNo || this.resaleNo.trim() === '') {
        Swal.fire({
          title: $localize`Warning`,
          text: $localize`Enter the resale number`,
          icon: "warning",
          confirmButtonText: $localize`Ok`,
        });
      }
      else {
        addToGrid = true;
        closeModalPopup = true;
        this.resaleOptionSelected = true;
      }

      if (closeModalPopup) {
        if (modal.classList.contains('show')) {
          modal.style.display = 'none';
          modal.classList.remove('show');
        }
      }

      if (addToGrid) {
        const obj = {
          VendorID: this.vendorId,
          ExemptResaleNo: false,
          ExemptResaleReason: "",
          ResaleNo: this.resaleNo,
          MarketId: this.marketId
        }

        this.subscriptions.push(this.rentalService.UpdateVendorResaleInfo(obj).subscribe((res: any) => {
        }));
      }
    }
    else {
      addToGrid = true;
    }

    if (addToGrid) {
      if (this.BusinessLicenseNumberRequired && this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
        var addToGrid = false;
        var closeModalPopup = false;
        if ((!this.businessLicenseNumber || this.businessLicenseNumber.trim() === '') || !this.businessLicenseExpiryDate) {
          this.ResaleOrBusinessHeader = "Business License Number"
          const modal = this.modalResaleNo.nativeElement;
          this.resaleNoDisplay = false;
          this.businessLicenseDisplay = true;
          modal.classList.add('show');
          if (modal.classList.contains('show')) {
            modal.style.display = 'block';
            this.ResaleOrBusinessHeader = "Business License Number"
          }
        }
        else if (this.getDateFromDateTime(new Date(this.businessLicenseExpiryDate)) < this.getDateFromDateTime(new Date())) {
          this.closeResaleModal();
          Swal.fire({
            text: $localize`Business License is expired! Please contact the market.`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });
        }
        else {
          addToGrid = true;
          this.closeResaleModal();
          if (this.businessLicenseDisplay) {
            const obj = {
              VendorID: this.vendorId,
              LicenseNameId: 1,
              LicenseName: "",
              ExpiryDate: new Date(this.businessLicenseExpiryDate),
              LicenseNumber: this.businessLicenseNumber
            }

            this.subscriptions.push(this.rentalService.updateVendorBusinessLicense(this.marketId, obj).subscribe((res: any) => {
            }));
          }
          this.addSelectedBoothsToGrid();
        }
      }
      else {
        addToGrid = true;
        closeModalPopup = true;
        this.addSelectedBoothsToGrid();
      }
    }
  }

  getDateFromDateTime(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  closeResaleModal() {
    const modal = this.modalResaleNo.nativeElement;
    if (modal.classList.contains('show')) {
      modal.style.display = 'none';
      modal.classList.remove('show');
    }
  }

  calculateAddToGrid(el, vendorProducts, date, res) {
    var totalEventDays = [];
    for (var date of this.selectedDays) {
      totalEventDays.push(this.datePipe.transform(date, "MM/dd/yyyy"))
    }
    var newbooths = [];
    const ob = {
      EventRentalId: 0,
      BoothNumber: el.BoothNumber,
      BoothType: el.BoothType,
      BoothTypeId: el.BoothTypeId,
      Product: vendorProducts,
      EventDate: this.rentalForm.get('eventOptions').value == "2" ? totalEventDays[0] : this.datePipe.transform(date, "MM/dd/yyyy"),
      EventRent: this.customCurrency.transform(res.Rent),
      SalesTax: this.customCurrency.transform(res.SalesTax),
      CityTax: this.customCurrency.transform(res.CityTax),
      NewBooth: true,
      EventName: this.eventList.filter(e => e.EventID == this.rentalForm.get('eventId').value)[0]?.EventName,
      TotalEvent: this.rentalForm.get('eventOptions').value == "2",
      TotalEventDays: totalEventDays
    }
    this.totalRentalCharge += res.Rent.toString().includes('(') && res.Rent.toString().includes(')') ? -1 * parseFloat(res.Rent.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.Rent.toString().replace(/[^0-9.-]/g, ''));
    this.totalSalesTax += res.SalesTax.toString().includes('(') && res.SalesTax.toString().includes(')') ? -1 * parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, ''));
    this.totalSecondLeveltax += res.CityTax.toString().includes('(') && res.CityTax.toString().includes(')') ? -1 * parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, ''));
    this.totalCharge = this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
    this.getDiscounts();
    this.gridEvents.refresh();
    newbooths.push(JSON.parse(JSON.stringify(ob)));
    this.selectedBooths = this.selectedBooths.concat(newbooths);
  }

  async addSelectedBoothsToGrid() {
    this.selectedBoothsForRental = [];
    if (this.selectedBoothData) {
      this.loaderIcon = Promise.resolve(true);
      if (this.rentalForm.get('eventOptions').value == "2") {
        for (const el of this.selectedBoothData) {
          var obj = {
            RentalDate: null,
            MarketId: this.marketId,
            BoothTypeId: el.BoothTypeId,
            VendorId: this.vendorId,
            TotalEvent: this.rentalForm.get('eventOptions').value == "2",
            EventId: this.rentalForm.get('eventId').value,
            WRNewVendorRequest: this.newVendor
          }
          var res = await lastValueFrom(this.rentalService.getBoothRentalEventCharges(obj));
          if (res) {
            var vendorProducts = !this.newVendor ? this.vendorProducts.filter(x => x.Priority) ? this.vendorProducts.filter(x => x.Priority)[0].ProductId : this.vendorProducts[0].ProductId:"";
            this.calculateAddToGrid(el, vendorProducts, null, res);
          }
          this.disableSave = false;
          this.isFormDirty.emit(true);
        }
        this.loaderIcon = Promise.resolve(false);
        this.refreshAddBooth();
      } else {
        for (const date of this.selectedDays) {
          this.selectedBoothData.map(async (el, i) => {
            var obj = {
              RentalDate: new Date(date),
              MarketId: this.marketId,
              BoothTypeId: el.BoothTypeId,
              VendorId: this.vendorId,
              TotalEvent: this.rentalForm.get('eventOptions').value == "2",
              EventId: this.rentalForm.get('eventId').value
            }
            var res = await lastValueFrom(this.rentalService.getBoothRentalEventCharges(obj));
            if (res) {
              var vendorProducts = this.vendorProducts.filter(x => x.Priority) ? this.vendorProducts.filter(x => x.Priority)[0].ProductId : this.vendorProducts[0].ProductId;
              this.calculateAddToGrid(el, vendorProducts, date, res);
            }
            this.disableSave = false;
            this.isFormDirty.emit(true);
          });
        }
        this.loaderIcon = Promise.resolve(false);
        this.refreshAddBooth();
      }
    }
  }

  updateOtherTotalRent(data) {
    if (parseFloat(data.Quantity) == 0) {
      data.Quantity = "1"
    }
    data.OtherItemCharge = data.OtherItemCharge ? data.OtherItemCharge : this.customCurrency.transform("0");
    this.totalSalesTax -= data.SalesTax.toString().includes('(') && data.SalesTax.toString().includes(')') ? -1 * parseFloat(data.SalesTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(data.SalesTax.toString().replace(/[^0-9.-]/g, ''));
    this.totalSecondLeveltax -= data.CityTax.toString().includes('(') && data.CityTax.toString().includes(')') ? -1 * parseFloat(data.CityTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(data.CityTax.toString().replace(/[^0-9.-]/g, ''));
    this.totalOtherRentalCharge -= data.OtherItemtotal.toString().includes('(') && data.OtherItemtotal.toString().includes(')') ? -1 * parseFloat(data.OtherItemtotal.toString().replace(/[^0-9.-]/g, '')) : parseFloat(data.OtherItemtotal.toString().replace(/[^0-9.-]/g, ''));
    this.totalCharge = this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
    
    const index = this.selectedOtherItems.findIndex(item => item.Id === data.Id && item.EventName == data.EventName && item.NewItem == true && item.BoothNo == data.BoothNo && item.Reference == data.Reference && item.TotalEvent == data.TotalEvent);
    if (index !== -1) {
      var obj = {
        MarketId: this.marketId,
        OtherItemId: data.Id,
        VendorId: this.vendorId,
        Quantity: data.Quantity,
        OtherItemCharge: data.OtherItemCharge.includes('(') && data.OtherItemCharge.includes(')') ? (-1) * parseFloat(data.OtherItemCharge.replace(/[^0-9.-]/g, '')) : parseFloat(data.OtherItemCharge.replace(/[^0-9.-]/g, ''))
      }
      this.subscriptions.push(this.rentalService.getOtherItemsRentalCharges(obj).subscribe((res: any) => {
        this.selectedOtherItems[index].SalesTax = this.customCurrency.transform(res.SalesTax.toString());
        this.selectedOtherItems[index].CityTax = this.customCurrency.transform(res.CityTax.toString());
        const isNegative = data.OtherItemCharge.includes('(') && data.OtherItemCharge.includes(')');
        const totalValue = parseFloat(data.OtherItemCharge.replace(/[^0-9.-]/g, ''));
        const finalCharge = isNegative ? -totalValue : totalValue;
        data.OtherItemtotal = this.customCurrency.transform((finalCharge * data.Quantity).toString());
        this.selectedOtherItems[index].OtherItemtotal = data.OtherItemtotal;
        this.selectedOtherItems[index].OtherItemCharge = this.customCurrency.transform(finalCharge.toString());
        this.selectedOtherItems[index].Quantity = data.Quantity;
        this.gridEvtOtherRentals.refresh();
        this.totalOtherRentalCharge += data.OtherItemtotal.toString().includes('(') && data.OtherItemtotal.toString().includes(')') ? -1 * parseFloat(data.OtherItemtotal.toString().replace(/[^0-9.-]/g, '')) : parseFloat(data.OtherItemtotal.toString().replace(/[^0-9.-]/g, ''));
        this.totalSalesTax += res.SalesTax.toString().includes('(') && res.SalesTax.toString().includes(')') ? -1 * parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, ''));
        this.totalSecondLeveltax += res.CityTax.toString().includes('(') && res.CityTax.toString().includes(')') ? -1 * parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, ''));
        this.totalCharge =  this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
       
        this.getDiscounts();
      }));
    }
  }

  checkboxChanged(args, item: any) {
    if (args.srcElement.checked) {
      this.selectedDays.push(new Date(item.MarketDays));
    } else {
      this.selectedDays = this.selectedDays.filter(day => day.getTime() !== new Date(item.MarketDays).getTime());
    }
    this.allAvailableBooths = [];
  }

  getEventMarketDays() {
    this.subscriptions.push(this.rentalService.getEventMarketDays(this.marketId, this.rentalForm.get('eventId').value).subscribe((res: any) => {
      if (res) {
        this.eventMarketDays = res;
        this.otherChargeMarketDay = this.eventMarketDays[0]?.MarketDays;
      }
    }));
  }

  searchOtherItem() {
    this.otherRentalCharges = this.otherItemList;
    if (this.otherItemSearchText != '') {
      this.otherRentalCharges = this.otherItemList.filter((ele) => ele.OtherItem.toString().toLowerCase().indexOf(this.otherItemSearchText.toLowerCase()) !== -1);
    }
  }

  refreshAddBooth() {
    this.getEventMarketDays();
    this.selectedBoothData = [];
    this.allAvailableBooths = [];
    this.isboothSelected = true;
    this.layoutParts = this.defaultPartId == 0 ? this.parts[0].PartId : this.defaultPartId;
    if (this.selectedBoothsForRental.length > 0) {
      this.selectedBoothsForRental.forEach(ele => {
        this.selectedDays.forEach(date => {
          const temp = {
            TempRecordNo: this.tempRecordNo.toString(),
            BoothNumber: ele.BoothNumber,
            StartDate: new Date(date),
            RentalType: 7
          }
          this.subscriptions.push(
            this.rentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
            })
          );
        });
      });
    }
    this.selectedDays = [];
    this.selectedBoothsForRental = [];
  }

  openOtherChargeModal() {
    this.getBoothsAndItemsForOtherCharges();
    const modal = this.modalOtherChargeOption.nativeElement;
    if (modal.classList.contains('show')) {
      $(modal).modal('hide');
      modal.classList.remove('show');
    }
    const modal1 = this.modalOtherCharges.nativeElement;
    if (!modal1.classList.contains('show')) {
      $(modal1).modal('show');
    }
  }

  addOtherCharges() {
    var totalEventDays = [];
    if (this.rentalForm.get('eventOptions').value == '2') {
      this.selectedOtherChargeDays = [];
      for (var item of this.eventMarketDays) {
        this.selectedOtherChargeDays.push(new Date(item.MarketDays));
        totalEventDays.push(this.datePipe.transform(new Date(item.MarketDays), "MM/dd/yyyy"))
      }
    }
    if (this.selectedOtherCharges) {
      this.loaderIcon = Promise.resolve(true);
      this.selectedOtherCharges.map((el, i) => {
        var obj = {
          MarketId: this.marketId,
          OtherItemId: el.Id,
          VendorId: this.vendorId,
          Quantity: el.Quantity,
          OtherItemCharge: el.OtherItemCharge.includes('(') && el.OtherItemCharge.includes(')') ? (-1) * parseFloat(el.OtherItemCharge.replace(/[^0-9.-]/g, '')) : parseFloat(el.OtherItemCharge.replace(/[^0-9.-]/g, '')),
          WRNewVendorRequest: this.newVendor
        }

        const index = this.selectedOtherItems.findIndex(item => item.Id === el.Id && this.rentalForm.get('eventOptions').value == el.otherChargeEventType && item.NewItem == true && item.EventName === el.EventName && item.Reference == el.Reference);
        this.subscriptions.push(this.rentalService.getOtherItemsRentalCharges(obj).subscribe((res: any) => {
          var newItem = [];
          if (index !== -1) {
            var otherItemTotal = this.selectedOtherItems[index].OtherItemtotal;
            var salesTax = this.selectedOtherItems[index].SalesTax;
            var cityTax = this.selectedOtherItems[index].CityTax;
            this.totalOtherRentalCharge -= otherItemTotal.toString().includes('(') && otherItemTotal.toString().includes(')') ? -1 * parseFloat(otherItemTotal.toString().replace(/[^0-9.-]/g, '')) : parseFloat(otherItemTotal.toString().replace(/[^0-9.-]/g, ''));
            this.totalSalesTax -= salesTax.toString().includes('(') && salesTax.toString().includes(')') ? -1 * parseFloat(salesTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(salesTax.toString().replace(/[^0-9.-]/g, ''));
            this.totalSecondLeveltax -= cityTax.toString().includes('(') && cityTax.toString().includes(')') ? -1 * parseFloat(cityTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(cityTax.toString().replace(/[^0-9.-]/g, ''));
            this.totalCharge = this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
           
            const ob = {
              Id: el.Id,
              OtherItem: el.OtherItem,
              OtherItemCharge: el.OtherItemCharge,
              Quantity: el.Quantity,
              OtherItemtotal: el.OtherItemtotal,
              EventDate: this.rentalForm.get('eventOptions').value == "2" ? totalEventDays[0] : this.datePipe.transform(el.RentalDay, "MM/dd/yyyy"),
              SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
              CityTax: this.customCurrency.transform(res.CityTax.toString()),
              BoothNo: el.othChgBooths,
              Reference: el.Reference,
              NewItem: true,
              EventName: this.eventList.filter(e => e.EventID == this.rentalForm.get('eventId').value)[0]?.EventName,
              TotalEvent: this.rentalForm.get('eventOptions').value == "2",
              TotalEventDays: totalEventDays
            }
            this.selectedOtherItems[index] = ob;
            this.gridEvtOtherRentals.refresh();
          }
          else {
            const ob = {
              Id: el.Id,
              OtherItem: el.OtherItem,
              OtherItemCharge: el.OtherItemCharge,
              Quantity: el.Quantity,
              OtherItemtotal: el.OtherItemtotal,
              EventDate: this.rentalForm.get('eventOptions').value == "2" ? totalEventDays[0] : this.datePipe.transform(el.RentalDay, "MM/dd/yyyy"),
              SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
              CityTax: this.customCurrency.transform(res.CityTax.toString()),
              BoothNo: el.othChgBooths,
              Reference: el.Reference,
              NewItem: true,
              EventName: this.eventList.filter(e => e.EventID == this.rentalForm.get('eventId').value)[0]?.EventName,
              TotalEvent: this.rentalForm.get('eventOptions').value == "2",
              TotalEventDays: totalEventDays
            }
            newItem.push(JSON.parse(JSON.stringify(ob)));
          }
          this.disableSave = false;
          this.isFormDirty.emit(true);

          if (newItem.length > 0) {
            this.selectedOtherItems = this.selectedOtherItems.concat(newItem);
          }
          this.totalOtherRentalCharge += el.OtherItemtotal.toString().includes('(') && el.OtherItemtotal.toString().includes(')') ? -1 * parseFloat(el.OtherItemtotal.toString().replace(/[^0-9.-]/g, '')) : parseFloat(el.OtherItemtotal.toString().replace(/[^0-9.-]/g, ''));
          this.totalSalesTax += res.SalesTax.toString().includes('(') && res.SalesTax.toString().includes(')') ? -1 * parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, ''));
          this.totalSecondLeveltax += res.CityTax.toString().includes('(') && res.CityTax.toString().includes(')') ? -1 * parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, ''));
          this.totalCharge = this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;  
          this.getDiscounts();
        }, err => {
          this.loaderIcon = Promise.resolve(false);
        }));
      });

      this.loaderIcon = Promise.resolve(false);
      const modal = this.modalOtherCharges.nativeElement;
      if (modal.classList.contains('show')) {
        modal.style.display = 'none';
        modal.classList.remove('show');
      }
    }
  }

  getActualAmountFromInp(value) {
    var amount = value.toString().includes('(') && value.toString().includes(')') ? -1 * parseFloat(value.toString().replace(/[^0-9.-]/g, '')) : parseFloat(value.toString().replace(/[^0-9.-]/g, ''));
    return amount;
  }

  saveRentalWithPayment() {
    this.isdirty = false;
    this.isFormDirty.emit(false);
    var bookingReceipt = this.selectedBooths.some(e => e.NewBooth == true) || this.selectedOtherItems.some(e => e.NewItem == true);
    var paymentDueDate = null;
    var totalDiscountCharge = 0

    var obj = {
      RentalType: 7,
      VendorId: this.vendorId,
      PriorBalance: this.priorBalance ?? 0,
      RentalCharge: this.totalRentalCharge,
      SalesTax: this.totalSalesTax,
      SecLevelTax: this.totalSecondLeveltax,
      OtherCharge: this.totalOtherRentalCharge,
      TotalBalanceDue: this.totalCharge,
      RentalNotes: "",
      RentalMethod: "",
      EventRentalBooth: [],
      EventRentalOtherCharges: [],
      TempRecordNo: this.tempRecordNo,
      ReceiptSettings: "",
      PaymentOnly: !bookingReceipt,
      ExemptResaleNo: false,
      ExemptResaleReason: "",
      ResaleNo: this.resaleNo,
      PaymentDueDate: this.DisplayPayDueDate ? paymentDueDate : null,
      AppliedDiscountModel: [],
      DiscountAmount: this.totalDiscountCharge ?? 0
    }

    var objSelectedBooth = [];
    if (this.selectedBooths.length > 0) {
      this.selectedBooths.forEach((item) => {
        if (item.NewBooth) {
          objSelectedBooth.push({
            EventRentalId: item.EventRentalId,
            BoothNumber: item.BoothNumber,
            BoothTypeId: item.BoothTypeId,
            ProductId: item.Product,
            BoothType: item.BoothType,
            DailyEventDay: item.EventDate != null ? new Date(item.EventDate) : null,
            TotalEvent: item.TotalEvent,
            TotalEventDays: item.TotalEventDays.map(e => new Date(e)),
            EventId: this.eventList.filter(e => e.EventName == item.EventName)[0]?.EventID,
            RentalCharge: this.getActualAmountFromInp(item.EventRent),
            SalesTax: this.getActualAmountFromInp(item.SalesTax),
            SecLevelTax: this.getActualAmountFromInp(item.CityTax),
          })
        }
      });
    }

    if (objSelectedBooth.length > 0)
      obj.EventRentalBooth = objSelectedBooth;

    var objSelectedOtherCharge = [];
    if (this.selectedOtherItems.length > 0) {
      this.selectedOtherItems.forEach((item) => {
        if (item.NewItem) {
          objSelectedOtherCharge.push({
            OtherItemId: item.Id,
            Quantity: item.Quantity,
            BoothNumber: item.BoothNo,
            OtherCharge: this.getActualAmountFromInp(item.OtherItemCharge),
            SalesTax: this.getActualAmountFromInp(item.SalesTax),
            SecLevelTax: this.getActualAmountFromInp(item.CityTax),
            Reference: item.Reference,
            DailyEventDay: item.EventDate != null ? new Date(item.EventDate) : null,
            TotalEvent: item.TotalEvent,
            TotalEventDays: item.TotalEventDays.map(e => new Date(e)),
            EventId: this.eventList.filter(e => e.EventName == item.EventName)[0]?.EventID
          })
        }
      });
    }
    if (objSelectedOtherCharge.length > 0)
      obj.EventRentalOtherCharges = objSelectedOtherCharge;

    var objDiscountData = [];
    if (this.vendorDiscountPlans.length > 0 && this.totalDiscountCharge > 0) {
      this.vendorDiscountPlans.forEach((item) => {
        if (item.CheckAll) {
          objDiscountData.push({
            PlanId: item.PlanSeqId,
            DiscountAmount: item.AppliedDiscount.includes('(') && item.AppliedDiscount.includes(')') ? -1 * parseFloat(item.AppliedDiscount.replace(/[^0-9.-]/g, '')) : parseFloat(item.AppliedDiscount.replace(/[^0-9.-]/g, '')),
            OtherCharges: item.OtherItems,
            SalesTax: item.SalesTaxApplied,
            SecondLevelTax: item.SecondLevelTaxApplied,
            DiscountType: item.DiscountType == DiscountType.Percentage ? "0" : "1",
            DiscountValue: item.DiscountValue,
            SalesTaxAmount: item.SalesTaxAmount.includes('(') && item.SalesTaxAmount.includes(')') ? -1 * parseFloat(item.SalesTaxAmount.replace(/[^0-9.-]/g, '')) : parseFloat(item.SalesTaxAmount.replace(/[^0-9.-]/g, '')),
            SecondLevelTaxAmount: item.SecondLevelTaxAmount.includes('(') && item.SecondLevelTaxAmount.includes(')') ? -1 * parseFloat(item.SecondLevelTaxAmount.replace(/[^0-9.-]/g, '')) : parseFloat(item.SecondLevelTaxAmount.replace(/[^0-9.-]/g, ''))
          })
        }
      });
    }
    if (objDiscountData.length > 0)
      obj.AppliedDiscountModel = objDiscountData;
    if (!this.newVendor) {
      this.sharedDataService.paymentSharedData = obj;
      var url = 'vendor-payments/rp';
      this.router.navigate([url]);
    }
    else {
      this.rentalBookingData.emit(obj);
    }
  }

  deleteSelectedBooth(data) {
    if (!data.NewBooth) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Old Booking cannot be deleted`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    else {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you want to delete the selected Booth?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.value) {
          const index = this.selectedBooths.findIndex(selectedBooth => selectedBooth.BoothNumber === data.BoothNumber && selectedBooth.EventName == data.EventName);
          if (index !== -1) {
            this.selectedBooths.splice(index, 1);
          }

          if (data.TotalEvent) {
            data.TotalEventDays.forEach(date => {
              this.deleteTemp(data.BoothNumber, new Date(date));
            });
          }
          else {
            this.deleteTemp(data.BoothNumber, new Date(data.EventDate));
          }

          this.totalRentalCharge -= data.EventRent.includes('(') && data.EventRent.includes(')') ? -1 * parseFloat(data.EventRent.replace(/[^0-9.-]/g, '')) : parseFloat(data.EventRent.replace(/[^0-9.-]/g, ''));
          this.totalSalesTax -= data.SalesTax.includes('(') && data.SalesTax.includes(')') ? -1 * parseFloat(data.SalesTax.replace(/[^0-9.-]/g, '')) : parseFloat(data.SalesTax.replace(/[^0-9.-]/g, ''));
          this.totalSecondLeveltax -= data.CityTax.includes('(') && data.CityTax.includes(')') ? -1 * parseFloat(data.CityTax.replace(/[^0-9.-]/g, '')) : parseFloat(data.CityTax.replace(/[^0-9.-]/g, ''));
          this.totalCharge = this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
          this.gridEvents.refresh();
          this.getDiscounts();
        }
      });
    }
  }

  deleteOtherRentalCharges(data) {
    if (!data.NewItem) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Old Booking cannot be deleted`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    else {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you want to delete the selected Other Charges?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.value) {
          const index = this.selectedOtherItems.findIndex(oth => oth.Id === data.Id && oth.EventName == data.EventName
            && oth.NewItem && (oth.Reference ?? "") == (data.Reference ?? "") && oth.OtherItemtotal == data.OtherItemtotal);
          if (index !== -1) {
            this.selectedOtherItems.splice(index, 1);
          }

          var selectedItems = this.otherRentalCharges.findIndex(item => item.Id == data.Id);
          if (selectedItems != -1) {
            this.subscriptions.push(this.rentalService.getOtherRentalItems(this.marketId).subscribe((response) => {
              if (response) {
                const masterChargeRecord = response.filter(item => item.OtherItemId == data.Id);
                if (masterChargeRecord) {
                  this.otherRentalCharges[selectedItems].Quantity = 0;
                  this.otherRentalCharges[selectedItems].othChgBooths = "none";
                  this.otherRentalCharges[selectedItems].OtherItemCharge = this.customCurrency.transform(masterChargeRecord[0].OtherItemCharge);
                  this.otherRentalCharges[selectedItems].OtherItemtotal = this.customCurrency.transform('0');
                  this.otherRentalCharges[selectedItems].Reference = ""
                }
              }
            }, (err) => {
            }));
          }
          this.totalOtherRentalCharge -= this.getActualAmountFromInp(data.OtherItemtotal);
          this.totalSalesTax -= this.getActualAmountFromInp(data.SalesTax);
          this.totalSecondLeveltax -= this.getActualAmountFromInp(data.CityTax);
          this.gridEvtOtherRentals.refresh();
          this.getDiscounts();
        }
      });
    }
  }

  rentOnlineNextTab() {
    this.saveRentalWithPayment();
    this.bookingFormCompleted.emit(true);
  }

  deleteTemp(boothNo, rentalDay) {
    const temp = {
      TempRecordNo: this.tempRecordNo.toString(),
      BoothNumber: boothNo,
      StartDate: new Date(rentalDay),
      RentalType: 7
    }
    this.subscriptions.push(
      this.rentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
      })
    );
  }

  ngOnDestroy(): void {
     const temp = {
      TempRecordNo: this.tempRecordNo.toString(),
      BoothNumber: ""
    }
    setTimeout(() => {
      this.subscriptions.push(
        this.rentalService.deleteFromTemp(this.marketId, temp).subscribe((res: any) => {
        })
      );
    }, 500);
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
